import {
  Home,
  Store,
  MapPin,
  Ruler,
  Building2,
  FileSpreadsheet,
  FileText,
  Ticket,
  BarChart3,
  TrendingUp,
  Activity,
  Users,
  Bell,
  Link2,
  GitCompare,
  ArrowRightLeft,
  Database,
  Download,
  UserCheck,
  UserCog,
  UsersRound,
  CreditCard,
  Tag,
  Bookmark,
  Package,
  Layers,
  Factory,
  Ban,
  Server,
  Monitor,
  HelpCircle,
  Mail,
  Phone,
  Map,
  CheckCircle2,
  DollarSign,
  FileBarChart,
  Receipt,
  ClipboardList,
  Boxes,
  Truck,
  ScrollText,
  Clock,
  History,
  ListChecks,
  Bot,
  Megaphone,
  Shield,
  Settings,
  Lock,
  Wallet,
  FileOutput,
  BookOpen,
  type LucideIcon,
} from 'lucide-react';

const iconMap: Record<string, LucideIcon> = {
  '/media/icons/duotune/menu/home.svg': Home,
  '/media/icons/duotune/menu/unilever-white.svg': Package,
  '/media/icons/duotune/menu/store.svg': Store,
  '/media/icons/duotune/menu/icon-regional.svg': MapPin,
  '/media/icons/duotune/menu/ruler.svg': Ruler,
  '/media/icons/duotune/menu/cashback.svg': DollarSign,
  '/media/icons/duotune/menu/lists2.svg': ListChecks,
  '/media/icons/duotune/menu/building.svg': Building2,
  '/media/icons/duotune/menu/document-sheet.svg': FileSpreadsheet,
  '/media/icons/duotune/menu/coupon2.svg': Ticket,
  '/media/icons/duotune/menu/document.svg': FileText,
  '/media/icons/duotune/menu/icon-positivacao.svg': TrendingUp,
  '/media/icons/duotune/menu/icon-ativacao.svg': Activity,
  '/media/icons/duotune/menu/apuracao3.svg': BarChart3,
  '/media/icons/duotune/menu/icon-alerts.svg': Bell,
  '/media/icons/duotune/menu/conecta/assoc_promoid_cupomid.svg': Link2,
  '/media/icons/duotune/menu/conecta/comp_benef_valor.svg': GitCompare,
  '/media/icons/duotune/menu/conecta/conecta.svg': ArrowRightLeft,
  '/media/icons/duotune/menu/conecta/extract.svg': Download,
  '/media/icons/duotune/menu/conecta/seller.svg': UserCheck,
  '/media/icons/duotune/menu/conecta/seller-group.svg': UsersRound,
  '/media/icons/duotune/menu/conecta/seller-mapping.svg': Map,
  '/media/icons/duotune/menu/conecta/blocklist-seller.svg': Ban,
  '/media/icons/duotune/menu/conecta/pedidos.svg': ClipboardList,
  '/media/icons/duotune/menu/conecta/lojista-customer.svg': Users,
  '/media/icons/duotune/menu/conecta/lojista-company.svg': Building2,
  '/media/icons/duotune/menu/conecta/ul-nao-ponderada.svg': Layers,
  '/media/icons/duotune/menu/conecta/ul-ponderada.svg': Boxes,
  '/media/icons/duotune/menu/conecta/vip.svg': Bookmark,
  '/media/icons/duotune/menu/conecta/grupo-lojista-root.svg': Shield,
  '/media/icons/duotune/menu/conecta/grupo-lojista-open.svg': Lock,
  '/media/icons/duotune/menu/conecta/conecta-extrato-lojista-customer-cnpj.svg': FileText,
  '/media/icons/duotune/menu/conecta/conecta-extrato-lojista-company-cnpj.svg': FileBarChart,
  '/media/icons/duotune/menu/conecta/vendedor.svg': UserCog,
  '/media/icons/duotune/menu/conecta/grupo-vendedor.svg': UsersRound,
  '/media/icons/duotune/menu/conecta/credit-limit.svg': CreditCard,
  '/media/icons/duotune/menu/conecta/voucher-primario.svg': Tag,
  '/media/icons/duotune/menu/conecta/voucher-secundario.svg': Ticket,
  '/media/icons/duotune/menu/conecta/produto.svg': Package,
  '/media/icons/duotune/menu/conecta/marca.svg': Bookmark,
  '/media/icons/duotune/menu/conecta/categoria.svg': Layers,
  '/media/icons/duotune/menu/conecta/industria.svg': Factory,
  '/media/icons/duotune/menu/conecta/blocklist-industria.svg': Ban,
  '/media/icons/duotune/menu/conecta/devit.svg': Monitor,
  '/media/icons/duotune/menu/conecta/devit-distribuidores.svg': Truck,
  '/media/icons/duotune/menu/conecta/devit-vendedores.svg': UserCog,
  '/media/icons/duotune/menu/conecta/devit-lojistas.svg': Store,
  '/media/icons/duotune/menu/conecta/freshdesk.svg': HelpCircle,
  '/media/icons/duotune/menu/conecta/freshdesk-lojista-company.svg': Building2,
  '/media/icons/duotune/menu/conecta/freshdesk-lojista-contact.svg': Users,
  '/media/icons/duotune/menu/conecta/freshdesk-vendedor.svg': UserCog,
  '/media/icons/duotune/menu/conecta/freshdesk-distribuidor.svg': Truck,
  '/media/icons/duotune/menu/conecta/diferencas.svg': GitCompare,
  '/media/icons/duotune/menu/conecta/diferencas/sellers.svg': UserCheck,
  '/media/icons/duotune/menu/conecta/diferencas/sellers-group.svg': UsersRound,
  '/media/icons/duotune/menu/conecta/diferencas/blocklist-seller.svg': Ban,
  '/media/icons/duotune/menu/conecta/diferencas/pedidos.svg': ClipboardList,
  '/media/icons/duotune/menu/conecta/diferencas/lojista.svg': Store,
  '/media/icons/duotune/menu/conecta/diferencas/lojista-customer.svg': Users,
  '/media/icons/duotune/menu/conecta/diferencas/lojista-company.svg': Building2,
  '/media/icons/duotune/menu/conecta/diferencas/vendedores.svg': UserCog,
  '/media/icons/duotune/menu/conecta/diferencas/produto.svg': Package,
  '/media/icons/duotune/menu/conecta/diferencas/marcas.svg': Bookmark,
  '/media/icons/duotune/menu/conecta/diferencas/industrias.svg': Factory,
  '/media/icons/duotune/menu/conecta/validacao/validacao.svg': CheckCircle2,
  '/media/icons/duotune/menu/conecta/validacao/golive.svg': Activity,
  '/media/icons/duotune/menu/conecta/validacao/estoque.svg': Boxes,
  '/media/icons/duotune/menu/conecta/validacao/email.svg': Mail,
  '/media/icons/duotune/menu/conecta/validacao/telefone.svg': Phone,
  '/media/icons/duotune/menu/conecta/validacao/sellermapping.svg': Map,
  '/media/icons/duotune/menu/conecta/validacao/cnpjmigrado.svg': FileText,
  '/media/icons/duotune/menu/datatransfer/data-transfer.svg': Database,
  '/media/icons/duotune/menu/datatransfer/meta-financeira.svg': DollarSign,
  '/media/icons/duotune/menu/datatransfer/nao-faturado.svg': Receipt,
  '/media/icons/duotune/menu/datatransfer/spreadsheet.svg': ScrollText,
  '/media/icons/duotune/menu/datatransfer/timegap.svg': Clock,
  '/media/icons/duotune/menu/datatransfer/multipatrocinadores2.svg': UsersRound,
  '/media/icons/duotune/menu/reports/reports.svg': FileBarChart,
  '/media/icons/duotune/menu/reports/pedidos.svg': ClipboardList,
  '/media/icons/duotune/menu/reports/cadastro-lojistas.svg': Store,
  '/media/icons/duotune/menu/reports/cadastro-vendedores.svg': UserCog,
  '/media/icons/duotune/menu/reports/distribuidor-prioritario.svg': Truck,
  '/media/icons/duotune/menu/reports/nota-fiscal.svg': Receipt,
  '/media/icons/duotune/menu/reports/ultimo-preco-estoque.svg': DollarSign,
  '/media/icons/duotune/menu/reports/promocoes.svg': Megaphone,
  '/media/icons/duotune/menu/reports/cadastro-produtos.svg': Package,
  '/media/icons/duotune/menu/reports/faixa-cep-lojista.svg': MapPin,
  '/media/icons/duotune/menu/api-manage-users.svg': Server,
  '/media/icons/duotune/menu/api-users2.svg': Users,
  '/media/icons/duotune/menu/api-services.svg': Monitor,
  '/media/icons/duotune/menu/icon-logs.svg': ScrollText,
  '/media/icons/duotune/menu/robot-ai-svgrepo-com.svg': Bot,
  '/media/icons/duotune/menu/campaign.svg': Megaphone,
  '/media/icons/duotune/menu/permissions.svg': Shield,
  '/media/icons/duotune/menu/infrapay.svg': Wallet,
  '/media/icons/duotune/menu/infrapay-report.svg': FileOutput,
  '/media/icons/duotune/menu/infrapay-historico-vouchers.svg': BookOpen,
  '/media/icons/duotune/menu/devops-servers.svg': Server,
  '/media/icons/duotune/menu/devops-tasks.svg': ListChecks,
  '/media/icons/duotune/menu/devops-users.svg': Users,
  '/media/icons/duotune/menu/devops-history.svg': History,
  '/media/icons/duotune/menu/devops-team.svg': UsersRound,
  '/media/icons/duotune/menu/permissions2.svg': Shield,
  '/media/icons/duotune/menu/settings.svg': Settings,
};

export function getIcon(path?: string): LucideIcon | null {
  if (!path) return null;
  return iconMap[path] || null;
}

export default iconMap;
